import React, { useEffect, useState } from 'react';
import Chart from 'chart.js';
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  Button,
  Form,
  Container
} from 'reactstrap';

import { buttonStyle } from 'layouts/LoginAutoAuth/components/utils';
import { useForm } from 'react-hook-form';
import ReactLoader from 'components/Loader';
import { chartOptions, parseOptions } from 'variables/charts.js';

import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { toISOFormat, firstDayOfMonth } from '../../../../shared/dataFormater';
import DefaultDashboardFieldsFilterForm from './form/DefaultFieldsFilterForm';
import CRMDashboardService from '../../../../service';
import randomColor from 'randomcolor';
import GraphicsProductsQuantityByPriceCatalog from './components/GraphicsProductsQuantityByPriceCatalog';
import GraphicsProductsMostSoldByPriceCatalog from './components/GraphicsProductsMostSoldByPriceCatalog';
import FormTooltip from 'components/Inputs/FormTooltip';

if (window.Chart) {
  parseOptions(Chart, chartOptions());
}

const SingleCatalogDashboards = () => {
  const [loading, setLoading] = useState(false);
  const { control, handleSubmit, setValue, getValues, register } = useForm();
  const systemConfiguration = useSelector((state) => state.systemConfiguration);
  const [productsCountByCatalog, setProductsCountByCatalog] = useState([]);
  const [productsMostSold, setProductsMostSold] = useState([]);

  const getDashboardProducts = (params) => {
    CRMDashboardService.getProductsCountByStageWithDate(params)
      .then((response) => {
        const content = response?.data?.data;
        setProductsCountByCatalog(content.productsCount);
        setProductsMostSold(content.productsCountMostSelled);
      })
      .catch((error) => {
        const errorMessage =
          error?.response?.data?.message ||
          error?.message ||
          'Ops, ocorreu um erro!';
        toast.error(errorMessage, {
          autoClose: 3000,
          closeOnClick: true
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    setLoading(true);

    const formatedData = {
      dateBegin: `${toISOFormat(firstDayOfMonth)}`,
      dateEnd: `${toISOFormat(new Date().toLocaleDateString('pt-br'))}`
    };

    getDashboardProducts(formatedData);
  }, []);

  if (loading) {
    return (
      <Row className="justify-content-md-center mt-4">
        <ReactLoader />
      </Row>
    );
  }

  const onSubmit = (data) => {
    try {
      let formatedData;

      formatedData = {
        ...data,
        dateBegin: `${toISOFormat(data.dateBegin)}`,
        dateEnd: `${toISOFormat(data.dateEnd)}`,
        filterDateBy: data.filterDateBy
      };

      getDashboardProducts(formatedData);
    } catch (err) {
      const errorMessage =
        err?.response?.data?.message || err?.message || 'Ops, ocorreu um erro!';
      toast.error(errorMessage, {
        autoClose: 3000,
        closeOnClick: true
      });
    }
  };

  const getGraphicLabels = () => {
    if (!productsCountByCatalog) return [];
    return productsCountByCatalog?.map((item) => item.name);
  };

  const getGraphicData = () => {
    if (!productsCountByCatalog) return [];
    return productsCountByCatalog?.map((item) => item.quantity);
  };

  const getGraphicColors = () => {
    if (!productsCountByCatalog) return [];
    return productsCountByCatalog?.map(() =>
      randomColor({ luminosity: 'random', hue: 'random' })
    );
  };

  const getGraphicTotalData = () => {
    if (!productsCountByCatalog) return 0;
    return productsCountByCatalog?.reduce(
      (acc, item) => acc + item.quantity,
      0
    );
  };

  const getGraphicLabelsMostSold = () => {
    if (!productsMostSold) return [];
    return productsMostSold?.map((item) => item.name);
  };

  const getGraphicDataMostSold = () => {
    if (!productsMostSold) return [];
    return productsMostSold?.map((item) => item.quantity);
  };

  const getGraphicColorsMostSold = () => {
    if (!productsMostSold) return [];
    return productsMostSold?.map(() =>
      randomColor({ luminosity: 'random', hue: 'random' })
    );
  };

  const getGraphicTotalDataMostSold = () => {
    if (!productsMostSold) return 0;
    return productsMostSold?.reduce((acc, item) => acc + item.quantity, 0);
  };

  return (
    <Container className="p-0">
      <Card>
        <CardBody>
          <div>
            <Form
              className="needs-validation"
              onSubmit={handleSubmit(onSubmit)}
            >
              <DefaultDashboardFieldsFilterForm
                setValue={setValue}
                control={control}
                getValues={getValues}
                register={register}
              />

              <br />

              <Button
                type="submit"
                style={buttonStyle(systemConfiguration.primary_color)}
                className="mb-2"
              >
                Buscar
              </Button>
            </Form>
            <Row>
              <Col>
                <Card>
                  <CardHeader>
                    <h6 className="surtitle">Visão Geral</h6>
                    <h5 className="h3 mb-0">
                      Quantidade de Produtos por Catálogo
                      <FormTooltip text="Produtos cadastrados em Leads e Oportunidades" />
                    </h5>
                  </CardHeader>
                  <CardBody>
                    <GraphicsProductsQuantityByPriceCatalog
                      filteredLabels={getGraphicLabels()}
                      filteredData={getGraphicData()}
                      filteredColors={getGraphicColors()}
                      count={getGraphicTotalData()}
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col>
                <Card>
                  <CardHeader>
                    <h6 className="surtitle">Visão Geral</h6>
                    <h5 className="h3 mb-0">
                      Produtos mais vendidos
                      <FormTooltip text="Produtos cadastrados em Oportunidades na fase do tipo Fechado Ganho" />
                    </h5>
                  </CardHeader>
                  <CardBody>
                    <GraphicsProductsMostSoldByPriceCatalog
                      filteredLabels={getGraphicLabelsMostSold()}
                      filteredData={getGraphicDataMostSold()}
                      filteredColors={getGraphicColorsMostSold()}
                      count={getGraphicTotalDataMostSold()}
                      productsData={productsMostSold}
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </CardBody>
      </Card>
    </Container>
  );
};

export default SingleCatalogDashboards;
